module.exports = __webpack_public_path__ + "static/media/ic_pre.6f859160.svg";